module.exports = __webpack_public_path__ + "static/media/split-screen.2e389741.svg";